import React from 'react'
import './Header.scss'
import {AppBar} from '@mui/material'
import {AuthenticatedTemplate} from '@azure/msal-react'
import Logo from './menuComponents/Logo'
import {SearchPhraseForm} from './menuComponents/SearchPhraseForm'
import GuildMenu from './menuComponents/GuildMenu'
import UserMenu from './menuComponents/UserMenu'
import ServicesMenu from './menuComponents/ServicesMenu'
import ItemListMenu from './menuComponents/ItemListMenu'
import Notifications from './menuComponents/Notification/Notifications'
import DrawerHeader from './classificationTreeDrawer/DrawerHeader'
import BannersComponent from '../banner/BannersComponent'
import {useDatxPathGenerator, useSearchNavigateWithPathName} from '../util/routing'
import {ROUTES} from '../constants/routing'

const SearchHeader = ({hideSearch = false}: { hideSearch?: boolean }) => {
    const navigate = useSearchNavigateWithPathName()
    const generatePath = useDatxPathGenerator()
    const onSearch = (event: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLElement>, inputText: string) => {
        navigate({
            pathname: generatePath(ROUTES.search.path),
            search: inputText
        })
    }

    return <div className="search-header">
        {!hideSearch && <>
            <SearchPhraseForm onSearch={onSearch} inputTestId="header-search-field"
                              tooltipMessage="Please type at least 3 characters to perform a search"
            />
        </>}
    </div>
}

const Divider = () => <div className="header-divider"/>

const NavigationHeader = () => (
    <div className="navigation-header">
        <GuildMenu/>
        <ServicesMenu/>
        <ItemListMenu/>
        <Divider/>
        <Notifications/>
        <Divider/>
        <UserMenu/>
    </div>
)
const Header = ({
                    hideSearch = false
                }: { hideSearch?: boolean }) => {

    return (<div className="main-header-container" id="main-header-container">
            <AppBar className="main-header" id="main-header" position="relative">
                <div className="app-bar-left">
                    <Logo/>
                    <Divider/>
                    <DrawerHeader/>
                </div>
                <AuthenticatedTemplate>
                    <SearchHeader hideSearch={hideSearch}/>
                    <NavigationHeader/>
                </AuthenticatedTemplate>
            </AppBar>
            <BannersComponent/>
        </div>
    )
}

export default Header
